import { CommonIcons } from 'components/Icons';
import { TooltipReactTooltip } from 'components/Tooltip';
import { SIZE_ICON } from 'consts/data';
import useTheme from 'hooks/useTheme';
import React from 'react';

const propTypes = {};

const ThemeSwitcher = (props) => {
  //! State
  const { toggleTheme, isDarkTheme } = useTheme();
  const IconTheme = isDarkTheme ? CommonIcons.Sun : CommonIcons.Moon;

  //! Function

  //! Render
  // TEX-323: name the icon on hover, matching the diamond ("Premium service") and
  // Processes icons. The label is what a click switches to (moon → Dark mode, sun → Light mode).
  return (
    <TooltipReactTooltip
      delayShow={300}
      idTarget='tooltip-theme-switcher'
      messageToolTip={isDarkTheme ? 'Light mode' : 'Dark mode'}
    >
      <IconTheme
        style={{ width: SIZE_ICON, height: SIZE_ICON, transform: 'translateY(2px)' }}
        className='component:ThemeSwitcher is-hover'
        onClick={toggleTheme}
      />
    </TooltipReactTooltip>
  );
};

ThemeSwitcher.propTypes = propTypes;
export default React.memo(ThemeSwitcher);
